import React, { useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useStaleAppVersion } from '../../hooks/useStaleAppVersion';
import { hardRefreshApp } from '../../utils/appVersion';

const StaleAppBanner = () => {
  const isStale = useStaleAppVersion();
  const [refreshing, setRefreshing] = useState(false);

  if (!isStale) {
    return null;
  }

  const handleRefresh = async () => {
    setRefreshing(true);
    await hardRefreshApp();
  };

  return (
    <Alert
      variant="warning"
      className="mb-0 rounded-0 text-center stale-app-banner"
      role="status"
      style={{ position: 'sticky', top: 0, zIndex: 1050 }}
    >
      <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
        <span>A new version of the portal is available. Refresh to update.</span>
        <Button
          variant="dark"
          size="sm"
          onClick={handleRefresh}
          disabled={refreshing}
        >
          {refreshing ? 'Refreshing...' : 'Refresh'}
        </Button>
      </div>
    </Alert>
  );
};

export default StaleAppBanner;
